<section class="login-wrapper">
  <div class="left-set">
    <div class="img-wrapper">
      <img src="assets/images/monkey-pen-bg.jpg" alt="Login Image" />
    </div>
  </div>
  <div class="right-set">
    <div class="logo-wrapper">
      <img src="assets/images/monkeypenLogo.avif" alt="Logo" />
    </div>
    <div class="form-wrapper">
      <h2 class="cmn-heading-1">Login</h2>
      <div class="form-content">
        <form [formGroup]="loginForm" (ngSubmit)="login()">
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label>Email Address</mat-label>
              <input
                type="email"
                matInput
                placeholder="Enter your email"
                formControlName="email"
                (input)="onEmailInput($event)"
              />
              <mat-error *ngIf="loginForm.get('email')?.hasError('required')"
                >Email is required</mat-error
              >
              <mat-error *ngIf="loginForm.get('email')?.hasError('pattern')"
                >Enter a valid email</mat-error
              >
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field>
              <mat-label>Password</mat-label>
              <input
                id="password"
                matInput
                [type]="hide() ? 'password' : 'text'"
                placeholder="Enter your Password"
                formControlName="password"
              />
              <button
                mat-icon-button
                matSuffix
                [attr.aria-label]="'Toggle password visibility'"
                (click)="clickEvent($event)"
                type="button"
              >
                <mat-icon>{{
                  hide() ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-error *ngIf="loginForm.get('password')?.hasError('required')"
                >Password is required</mat-error
              >
            </mat-form-field>
          </div>
          <div class="btn-wrapper">
            <button type="submit">
              <span *ngIf="!loading">Login</span>
              <span *ngIf="loading">Loading...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<app-fullscreen-loader
  [visible]="loading"
  [message]="'Loading, please wait...'"
  [bgColor]="'#ECE8FF'"
>
</app-fullscreen-loader>
